'use strict';
angular.module('cvsApp').factory('findProfilesModel',[function() {

    var findProfilesModel = function(){

        var apiResponse = {};

        var that = this;

        this.getResponse = function(){
            return this;
        }

        this.setResponse = function(data){
            apiResponse = data;
        }
      
        // this.getError = function(){
        //     if(apiResponse.hasOwnProperty("header") &&  (apiResponse.header.statusCode !="0000")){
        //         apiResponse.showError = that.getHeader();
        //         return apiResponse.showError;
        //     }
        //     else if(apiResponse.hasOwnProperty("header") && apiResponse.header.statusCode != "0000"){
        //         apiResponse.showError = apiResponse.header;
        //         return apiResponse.showError;
        //     }
        //     return "";
        // }
        
        this.getHeader = function () {
            return apiResponse.resolveProfileConflictBotResponse.header;
        }

        this.getAuthResponse = function () {
            if (!apiResponse.showError) {
                return apiResponse.resolveProfileConflictBotResponse.details;
            }
        }

        // this.getstatusCode = function () {
        //     return apiResponse.statusCode;
        // }

        // this.getresponse = function(){
        //     if(!apiResponse.showError){
        //         return apiResponse.passwordResetResponse.details;
        //     }
        // }        

    }

    return new findProfilesModel();

    }]);